import { render, staticRenderFns } from "./StakeBox.vue?vue&type=template&id=a2e87be4&scoped=true"
import script from "./StakeBox.vue?vue&type=script&lang=js"
export * from "./StakeBox.vue?vue&type=script&lang=js"
import style0 from "./StakeBox.vue?vue&type=style&index=0&id=a2e87be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e87be4",
  null
  
)

export default component.exports